import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "NotFoundPage" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("message.NotFound")) + "(404)", 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.YouEnterInvalidURL")), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.CheckURL")), 1),
      _hoisted_2,
      _createVNode(_component_router_link, {
        to: _ctx.routerPath('/'),
        class: "ToHome"
      }, {
        default: _withCtx(() => [
          _createTextVNode("< " + _toDisplayString(_ctx.$t("message.Home")), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _hoisted_3,
    _hoisted_4,
    _hoisted_5
  ], 64))
}